var guess = require('./mimeType');
var pattern = /^([\d\.]+)([mkg]?b?)$/i;
var logger = require('./logger');
function noop() {
    return true;
}
function isFunction(func) {
    return func && {}.toString.call(func) === '[object Function]';
}

function unique(arr) {
    var _arr = [];
    arr.forEach(function (item) {
        if (_arr.indexOf(item) === -1) {
            _arr.push(item);
        }
    });
    return _arr;
}

function parseSize(size) {
    if (typeof size === 'number') {
        return size;
    }
    // mb MB Mb M
    // kb KB kb k
    // 100
    var match = pattern.exec(size);
    if (!match) {
        return 0;
    }

    var $1 = match[1];
    var $2 = match[2];
    if (/^k/i.test($2)) {
        return $1 * 1024;
    } else if (/^m/i.test($2)) {
        return $1 * 1024 * 1024;
    } else if (/^g/i.test($2)) {
        return $1 * 1024 * 1024 * 1024;
    }
    return +$1;
}

function getMimeType(file) {
    var fileName = file.name;
    var ext = fileName.split(/\./g).pop();
    var mimeType = guess(ext);
    if (/^text\//.test(mimeType)) {
        mimeType += '; charset=UTF-8';
    }
    return mimeType;
}

function expandAccept(accept) {
    var exts = [];
    if (typeof accept === 'string') {
        exts = accept.split(',');
    }
    // 为了保证兼容性，把 mimeTypes 和 exts 都返回回去
    var rules = exts.map(function (ext) {
        if (ext.indexOf('/') !== -1) {
            return ext;
        }
        return guess(ext);
    });
    var mimeTypes = unique(rules);
    return unique(mimeTypes.concat(exts)).join(',');
}

/**
 * 文件扩展名
 */
function getFileExt(fileName) {
    var ext = (fileName || '').split(/\./g).pop();
    return ext;
}

/**
 * @description 大小检查
 */
function isOverMaxSize(file, maxSize, callback) {
    var status = false;
    callback = callback || noop;
    var maxFileSize = parseSize(maxSize);
    if (maxFileSize > 0 && file.size > maxFileSize) {
        // options.onOverMaxSize.apply(null, arguments);
        callback();
        status = true;
    }
    return status;
}

function getURLOriginFromURLString(urlString) {
    if (!urlString) {
        logger.error('[umu-upload] getURLOriginFromURLString urlString is empty');
        return '';
    }

    try {
        var urlVal = new URL(urlString);
        return urlVal.origin;
    } catch (err) {
        logger.error('[umu-upload] getURLOriginFromURLString URL error', err);
        return '';
    }
}

/**
 * co和大发暂不处理
 * https://umu-pd.slack.com/archives/C02U370J4TG/p1685434467134869
 * @see https://app.asana.com/0/1203622320206279/1204456467681048
 * @param {*} path
 * @returns
 */
var awsBucketsMap = {
    's3.us-west-2.amazonaws.com/umu.com': 'statics.umu.com',
    's3.ap-northeast-1.amazonaws.com/umu.tw': 'statics.umu.tw',
    's3.eu-west-1.amazonaws.com/umu.io': 'resource.umu.io',
    'umu-jp-f7hbh6ryp6ekj76yujucf6thrp5u6apn1a-s3alias.s3.ap-northeast-1.amazonaws.com': 'd1dw9odj9f4xrp.cloudfront.net'
    // 's3.ap-northeast-1.amazonaws.com/umu.co': 'co.umustatic.com',
    // 'umu-daihatsu.s3.ap-northeast-1.amazonaws.com': 'daihatsu.umustatic.com',
};

function replaceAWSPath(path) {
    Object.keys(awsBucketsMap).forEach(function (key) {
        if (path.indexOf(key) > -1) {
            path = path.replace(key, awsBucketsMap[key]);
        }
    });
    return path;
}

var hasResourceCallback = function (mediaType) {
    return ['picweike', 'docweike', 'videoweike'].includes(mediaType);
};

module.exports = {
    noop: noop,
    isFunction: isFunction,
    parseSize: parseSize,
    getMimeType: getMimeType,
    expandAccept: expandAccept,
    getFileExt: getFileExt,
    isOverMaxSize: isOverMaxSize,
    hasResourceCallback: hasResourceCallback,
    getURLOriginFromURLString: getURLOriginFromURLString,
    replaceAWSPath: replaceAWSPath
};
